import { Injectable } from '@angular/core';
import { VEHICLE_COLORS } from '../constants/color.constants';

@Injectable({
  providedIn: 'root'
})
export class ColorService {
  private assignedColors: Map<string, string> = new Map();
  private unassignedColors: string[] = [...VEHICLE_COLORS];
  private currentIndex: number = 0;

  constructor() {}

  getUniqueColor(guId: string): string {
    if (this.assignedColors.has(guId)) {
      return this.assignedColors.get(guId)!;
    }

    if (this.unassignedColors.length === 0) {
      this.unassignedColors = [...VEHICLE_COLORS];
      this.currentIndex = 0;
    }

    let color: string;

    // Assign the next color in sequence if available
    if (this.currentIndex < this.unassignedColors.length) {
      color = this.unassignedColors[this.currentIndex];
      this.currentIndex++;
    } else {
      // If the sequence is exhausted, randomly select from the unassigned colors
      const randomIndex = Math.floor(Math.random() * this.unassignedColors.length);
      color = this.unassignedColors[randomIndex];
    }

    // Remove the assigned color from the unassigned list and add to the assigned set
    this.unassignedColors = this.unassignedColors.filter(c => c !== color);
    this.assignedColors.set(guId, color);

    return color;
  }

  releaseColor(guId: string): void {
    if (this.assignedColors.has(guId)) {
      const color = this.assignedColors.get(guId)!;
      this.assignedColors.delete(guId);
      this.unassignedColors.push(color);
      this.currentIndex = Math.max(0, this.currentIndex - 1);
    }
  }

  reset(): void {
    this.assignedColors.clear();
    this.unassignedColors = [...VEHICLE_COLORS];
    this.currentIndex = 0;
  }
}
